const servicesByType = (services: any) => {
  let mjrServices: number = 0;
  let mnrServices: number = 0;
  let pdiServices: number = 0;
  let frsServices: number = 0;
  let rglServices: number = 0;
  services.forEach((service: any) => {
    if (service?._id?.service === "Major Service") {
      mjrServices = mjrServices + service.invoice_value;
    }
    if (service?._id?.service === "Minor Service") {
      mnrServices = mnrServices + service.invoice_value;
    }
    if (service?._id?.service === "P.D.I.") {
      pdiServices = pdiServices + service.invoice_value;
    }
    if (service?._id?.service === "Regular service") {
      rglServices = rglServices + service.invoice_value;
    }
  });

  const data = [
    {
      id: "Major Service",
      label: "Major Service",
      value: mjrServices,
      color: "hsl(280, 70%, 50%)",
    },
    {
      id: "Minor Services",
      label: "Minor Services",
      value: mnrServices,
      color: "hsl(345, 70%, 50%)",
    },
    {
      id: "P.D.I",
      label: "P.D.I",
      value: pdiServices,
      color: "hsl(354, 70%, 50%)",
    },
    {
      id: "Regular Services",
      label: "Regular Services",
      value: rglServices,
      color: "hsl(100, 70%, 50%)",
    },
  ];
  return data;
};

export default servicesByType;
